import { fetchApi } from '@/config/axiosSetting';
import { PatchPartOneVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPartOneVehicleInformation/patchPartOneVehicleInformation.type';

export const patchPartOneVehicleInformationFunction = ({
  id,
  damaged_id,
  data,
}: PatchPartOneVehicleInformationType) => {
  return fetchApi.patch(
    `/property/reports/${id}/accident_users/damaged/vehicle_information/part_one/?damaged_id=${damaged_id}`,
    {
      ...data,
    },
  );
};
